import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import icons_group from '../../other/icons_group.json';
import icons_bn from '../../other/icons_bn.json';

export default function AppsReviewCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.rootNarrow}>
      <CardContent className={classes.content}>
        <Grid container direction="row" justify="space-between">
          <Avatar aria-label="recipe" className={classes.avatar}
            style={{ backgroundColor: props.data.Color && props.data.Color.length > 5 ? `#${props.data.Color}` : '#E45670' }}
            src={props.data.Icon}
          >
          </Avatar>

          <Grid item container
            direction="row"
            justify="center"
            alignItems="center" style={{ height: 40, width: 40, backgroundColor: '#F6F6FB', borderRadius: '50%' }}>
            <Typography component="p" style={{ color: '#8987A2', fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '14px', lineHeight: '18px', textAlign: 'center' }}>
              {props.data.app_count}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="column" justify="flex-start" alignItems="flex-start" style={{ marginTop: 8 }}>
          <Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody} style={{ width: '100%' }}>
            {props.data[`Title`]}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  rootNarrow: {
    // maxWidth: 345,
    boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    minHeight: 205,
    height: 205,
    maxHeight: 205,
    minWidth: 312,
    '&:hover': {
      boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
    }
  },

  rootWide: {
    // maxWidth: 345,
    boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
    borderRadius: theme.spacing(2),
    paddingTop: 10,
    paddingBottom: 16,
    padding: theme.spacing(3),
    minHeight: 246,
    height: 246,
    maxHeight: 246,
    minWidth: 312,
    '&:hover': {
      boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
    }
  },

  avatar: {
    // backgroundColor: props.iconColor,
    height: 62,
    width: 62,
    borderRadius: 24,
    padding: 15
  },

  icon: {
    marginLeft: 8,
    backgroundColor: '#F6F6FB',
    width: 48,
    height: 48,
    '&:hover': {
      backgroundColor: '#F6F6FB',
    },
    '&:first-child': {
      marginLeft: 'auto',
    }
  },

  content: {
    // height: 289,
    // overflow: 'hidden',
    padding: 0,
    // marginTop: theme.spacing(1)
  },

  contentBody: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#000000'
  },

  contentSubbody: {
    marginTop: theme.spacing(1),
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '16px',
    color: '#8987A2'
  },

  header: {
    padding: 0,
    title: {
      fontSize: 22
    }
  },

  subheader: {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 400,
    color: '#8987A2'
  },

  actions: {
    padding: '0',
    paddingTop: '7',
    // position: 'absolute',
    // bottom: 16,
    // right: 24
  },

  pricePrimary: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#000'
  },

  priceSecondary: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#8987A2'
  }
}));

const CustomCardHeader = withStyles((theme) => ({
  root: {
    alignItems: 'flex-start'
  },

  avatar: {
    marginRight: 8
  },
}))(CardHeader);
